import { Component } from '@angular/core';
import { FinSantanderCnabService } from 'src/app/service/fin-santander-cnab.service';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-importar-retorno-cnab',
  templateUrl: './importar-retorno-cnab.component.html',
  styleUrls: ['./importar-retorno-cnab.component.scss']
})
export class ImportarRetornoCnabComponent {
  arquivoRetorno: File | null = null;
  processandoRetorno = false;

  constructor(
    private santanderCnab: FinSantanderCnabService,
    private util: UtilService
  ) {}

  onArquivoRetornoChange(ev: Event): void {
    const input = ev.target as HTMLInputElement;
    const f = input.files?.[0];
    this.arquivoRetorno = f || null;
  }

  enviarRetorno(): void {
    if (!this.arquivoRetorno) {
      this.util.toasterShowWarning('Retorno', 'Selecione um arquivo .RET.');
      return;
    }
    this.processandoRetorno = true;
    this.util.showLoading();
    this.santanderCnab.processarRetornoArquivo(this.arquivoRetorno).subscribe({
      next: (response: any) => {
        this.util.closeLoading();
        this.processandoRetorno = false;
        if (response?.hasErrors) {
          this.util.toasterShowError('Retorno', response.message || 'Falha ao processar.');
          return;
        }
        const d = this.desempacotarResponse(response);
        const liq = Number(d.liquidacoes ?? 0);
        const conf = Number(d.entradasconfirmadas ?? 0);
        const rej = Number(d.entradasrejeitadas ?? 0);
        this.util.toasterShowSuccess(
          'Retorno processado',
          `Confirmações: ${conf} · Rejeições: ${rej} · Liquidações: ${liq}.`
        );
        this.arquivoRetorno = null;
      },
      error: () => {
        this.util.closeLoading();
        this.processandoRetorno = false;
        this.util.toasterShowError('Erro', 'Não foi possível enviar o arquivo de retorno.');
      }
    });
  }

  private desempacotarResponse(response: any): any {
    let atual = response;
    for (let i = 0; i < 3; i++) {
      if (atual && typeof atual === 'object' && Object.prototype.hasOwnProperty.call(atual, 'data') && atual.data != null) {
        atual = atual.data;
      } else {
        break;
      }
    }
    return this.util.converterParaLowercase(atual ?? {});
  }
}
